import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M45 45H0V17.2h10.6l2.5 6.5h18.5l2.5-6.5H45V45zM2.5 42.5h40V19.7H36l-2.5 6.5h-22L9 19.7H2.5v22.8z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "23.8 11.3 23.8 0 21.3 0 21.3 11.3 18.8 11.3 22.5 17.8 26.3 11.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M37.9 38.8h-2c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2h2c.7 0 1.2.6 1.2 1.2s-.5 1.2-1.2 1.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M30.8 38.8h-13c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2h13c.7 0 1.2.6 1.2 1.2s-.5 1.2-1.2 1.2z"
		})
	]
});
export default SvgIcon;
